import { render } from "./museumRead.vue?vue&type=template&id=5e3c51a6"
import script from "./museumRead.vue?vue&type=script&lang=js"
export * from "./museumRead.vue?vue&type=script&lang=js"

import "./museumRead.vue?vue&type=style&index=0&id=5e3c51a6&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__